import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  loading: false,
  alertMsg: ''
};

const managequesSlice = createSlice({
  name: 'manageques',
  initialState: INITIAL_STATE,
  reducers: {
    startLoading(state) {
      state.loading = true;
      state.getList = false;
    },
    stopLoading(state) {
      state.loading = false;
    }
  }
});

export const managequesAction = managequesSlice.actions;

export default managequesSlice.reducer;
